/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PayrockMerchants } from './payrock-merchants';

/**
 *
 * @export
 * @interface Payrock
 */
export class Payrock {
    /**
     *
     * @type {string}
     * @memberof Payrock
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payrock
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payrock
     */
    type: string;
    /**
     *
     * @type {PayrockMerchants}
     * @memberof Payrock
     */
    merchants: PayrockMerchants;
    /**
     *
     * @type {boolean}
     * @memberof Payrock
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payrock
     */
    autoApprove: boolean;
    /**
     *
     * @type {string}
     * @memberof Payrock
     */
    apiBaseUrl?: string;
}
